// @flow

import { observer } from "mobx-react";
import React from "react";

import ImageHelper from "app/util/ImageHelper";

import defaultAvatar from "app/assets/images/avatar.png";
import "./UserThumbnail.scss";

type Props = {
    name?: string,
    image?: string
};

@observer
export default class UserThumbnail extends React.Component<Props> {
    render() {
        let thumbnail;
        if (this.props.image) {
            thumbnail = ImageHelper.makeUrl(this.props.image, "jpg", {
                width: 64,
                height: 64
            });
        } else {
            thumbnail = defaultAvatar;
        }

        return (
            <img
                className="UserThumbnail"
                src={thumbnail}
                alt={this.getName()}
            />
        );
    }

    getName() {
        if (!this.props.name) {
            return null;
        }

        return `${this.props.name} profile`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/UserThumbnail/UserThumbnail.js